import * as React from 'react';
import { Stack, PrimaryButton, getTheme, DetailsList, DetailsListLayoutMode, IColumn, SelectionMode, IDetailsRowProps, DetailsRow, Spinner, IconButton, Dialog, DialogFooter, DefaultButton, Icon } from 'office-ui-fabric-react';
import { PageURL } from '../../App';
import './Welcome.scss';
import "./AppCommonStyles.scss";
import { LoginComponent } from '../LoginComponent/LoginComponent';
import DataProvider from '../../dataprovider/DataProvider';
import moment from 'moment';
import AllBrandsLogo from '../../images/welcome/AllBrands.png';
//import StraumannLogo from '../../images/welcome/Straumann.png';
// import NeodentLogo from '../../images/welcome/Neodent.png';
// import AnthogyrLogo from '../../images/welcome/Anthogyr.png';
// import MendentikaLogo from '../../images/welcome/Mendentika.png';
// import ClearcorrectLogo from '../../images/welcome/Clearcorrect.png';

export interface IWelcomePageProps {
    location: Location;
    history: any;
    stepSizeClass: string;
    isLoggedIn: boolean;
    dataProvider: DataProvider;
    currentUser?: any;//IUserAccount;

    setAuthStatus: (loggedIn: boolean, user: any) => Promise<void>;
}

export interface IWelcomePageState {
    isLoggedIn: boolean;
    myItems?: any[];
    isLoading: boolean;
    isDeleteConfirmationOpen: boolean;
    selectedItem: any;
    isDeleting: boolean;
}

export class WelcomePage extends React.Component<IWelcomePageProps, IWelcomePageState> {

    private _columns: IColumn[] = [
        { key: 'studyTitle', name: 'Study Title', fieldName: 'studyTitle', minWidth: 270, maxWidth: 300, isResizable: true },
        { key: 'propId', name: 'Proposal ID', fieldName: 'proposalID', minWidth: 100, maxWidth: 130, isResizable: true },
        { key: 'summary', name: 'Summary', fieldName: 'summary', minWidth: 270, maxWidth: 300, isResizable: true },
        { key: 'created', name: 'Created', fieldName: 'created', minWidth: 100, maxWidth: 100, isResizable: false },
        { key: 'actions', name: '', fieldName: null, minWidth: 40, maxWidth: 40, isResizable: false },
    ]

    constructor(props: IWelcomePageProps) {
        super(props);

        this.state = {
            isLoggedIn: props.isLoggedIn,
            myItems: [],
            isLoading: false,
            isDeleteConfirmationOpen: false,
            selectedItem: null,
            isDeleting: false
        };
        this.setLoggedInInformation();

    }
    public componentDidMount() {
        console.log("Welcomepage componentDidMount");

    }

    public componentWillReceiveProps(newProps: IWelcomePageProps) {
        console.log("WelcomePage componentWillReceiveProps");
        if (this.state.isLoggedIn != newProps.isLoggedIn) {
            this.setState({ isLoggedIn: newProps.isLoggedIn }, () => {
                this.setLoggedInInformation();
            });
        }
    }

    private setLoggedInInformation() {
        console.log("setLoggedInInof: " + this.state.isLoggedIn);
        if (this.state.isLoggedIn && this.props.currentUser) {
            this.setState({ isLoading: true });
            this.props.dataProvider.getAllProposals(this.props.currentUser.userId).then(items => {
                console.log(items);
                this.setState({ myItems: items });
            }).catch((err) => {
                console.log("Error trying to load proposals: " + err);
                this.setState({ myItems: [] });
            }).finally(() => {
                this.setState({ isLoading: false });
            });
        } else {
            this.setState({ myItems: [] });

        }
    }
    private _renderRow = (props: IDetailsRowProps): JSX.Element => {
        if (props) {
            return <div onClick={() => this._onDetailsLineClick(props.item)}><DetailsRow {...props} /></div>;
        }
    }


    private _onDetailsLineClick = (item: any) => {
        this.props.history.push(PageURL.CreateProposal + "?id=" + item.id);
        //alert("clicked: " + JSON.stringify(item));
    }

    private _renderItemColumn = (item: any[], index: number, column: IColumn) => {
        const fieldContent = (item as any)[column.fieldName as string] as string;

        switch (column.key) {
            case 'created':
                return Boolean(fieldContent) ? moment(new Date(fieldContent)).format("DD.MM.YYYY") : null;
            case 'actions':
                return <IconButton iconProps={{ iconName: 'Delete' }} onClick={
                    (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.setState({
                            selectedItem: item,
                            isDeleteConfirmationOpen: true
                        });
                    }
                } />
            default:
                return fieldContent;
        }
    }

    private onDeleteClicked = () => {
        this.setState({ isDeleting: true });
        this.props.dataProvider.deleteProposal(this.state.selectedItem.id).then(() => {
            this.props.dataProvider.getAllProposals(this.props.currentUser.userId).then(items => {
                console.log(items);
                this.setState({ myItems: items, isLoading: false, isDeleting: false, isDeleteConfirmationOpen: false });
            });
        });
    };

    private onDismissDeleteDialog = () => {
        this.setState({
            selectedItem: null,
            isDeleteConfirmationOpen: false
        });
    };

    public render(): React.ReactElement<IWelcomePageProps> {

        return (
            <>
                <div className="formContainer">
                    <div className="row marginBottom10" style={{ height: '100%', width: '100%', margin: '0 -10px' }}>
                        <div className="brand-container">
                            <div className="brand-box">
                                <img src={AllBrandsLogo} alt="Straumann" className="brandbox-image" />
                            </div>
                        </div>
                        <div className="detail-container">
                            <div className='row' style={{ display: 'flex', flexDirection: 'column', gap: '20px', alignItems: 'center', width: '100%', justifyContent: this.props.isLoggedIn ? 'flex-start' : 'space-around', marginTop: '-15px' }}>
                                <Stack horizontalAlign="center" className="fullWidth">
                                    <h2>Straumann Group</h2>
                                    <h2>Investigator Initiated Studies Submission Portal</h2>
                                </Stack>

                                <div className="column12" style={{ fontSize: '20px', top: this.props.isLoggedIn ? '0px' : '-20px' }}>
                                    <Stack className="fullWidth" horizontalAlign="center">
                                        {
                                            !this.state.isLoggedIn ?
                                                <Stack className="fullWidth" horizontalAlign="center" tokens={{ childrenGap: '40' }}>
                                                    <div style={{ fontWeight: 'bold' }}>Please sign in to be able to create a request</div>
                                                    <LoginComponent setAuthStatus={this.props.setAuthStatus} currentUser={this.props.currentUser} />
                                                    <div>Before submitting <b><u>a clinical research proposal</u></b>, please review <a rel='noopener' href="./documents/guidelines for investigator_straumann group.pdf" target='_blank'>IIS guidelines</a></div>
                                                    <div style={{ marginTop: '10px' }}>We also support innovation projects. Please visit our dedicated <a rel='noopener' href='https://innovation.straumann.com' target='_blank'>HYPE portal</a> for more details.</div>
                                                    {/*  <div style={{ marginTop: '10px' }}>For more details visit the <a rel='noopener' href="https://www.straumann.com/en/dental-professionals/science/research-activities/investigator-initiated-studies.html" target='_blank'>Straumann® Investigator-Initiated Studies Program.</a></div>         */}

                                                </Stack>
                                                :
                                                <>
                                                    <Stack horizontal className="fullWidth" horizontalAlign="center">
                                                        <div style={{ height: '50px' }}>
                                                            <PrimaryButton
                                                                styles={{ label: { fontSize: '16px' } }}
                                                                text="Create new Proposal"
                                                                className="linkButton"
                                                                // disabled={!this.state.isLoggedIn}
                                                                onClick={() => {
                                                                    //sessionStorage.setItem("Country", country);
                                                                    // alert("clicked")
                                                                    this.props.history.push(PageURL.CreateProposal);
                                                                }}
                                                                allowDisabledFocus
                                                            />
                                                        </div>
                                                    </Stack>

                                                    <Stack horizontal className="fullWidth" horizontalAlign="center">
                                                        <div style={{ marginTop: '15px', marginLeft: '5px' }}>
                                                            {
                                                                this.state.myItems?.length > 0 ?
                                                                    <>
                                                                        <fieldset style={{ border: '1px solid #ddd', padding: '15px', boxShadow: '3px 3px 9px -3px #A09E9B', borderRadius: '5px' }}>
                                                                            <legend style={{ paddingLeft: '10px', paddingRight: '10px', width: 'initial', marginBottom: '0px' }}>My Draft Proposals</legend>
                                                                            {/*<h3>My draft proposals</h3>*/}
                                                                            <DetailsList
                                                                                className="tableStyle"
                                                                                items={this.state.myItems}
                                                                                columns={this._columns}
                                                                                setKey="set"
                                                                                layoutMode={DetailsListLayoutMode.justified}
                                                                                //constrainMode={ConstrainMode.horizontalConstrained}
                                                                                skipViewportMeasures={true}
                                                                                selectionPreservedOnEmptyClick={true}
                                                                                onRenderRow={this._renderRow}
                                                                                onRenderItemColumn={this._renderItemColumn}
                                                                                selectionMode={SelectionMode.none}
                                                                                styles={{ root: { paddingTop: '0px' } }}
                                                                            />
                                                                        </fieldset>
                                                                    </> : <>{this.state.isLoading ? <Spinner label="Looking for draft proposals" /> : null}</>
                                                            }
                                                        </div>
                                                    </Stack>
                                                </>

                                        }
                                    </Stack>
                                    {/*<fieldset className="contactUs">Contact us: <a href="mailto:research-screening@straumann.com">Research Screening</a></fieldset>*/}
                                    <Stack className="fullWidth" style={{ paddingTop: '20px' }} horizontal horizontalAlign={'end'} tokens={{ childrenGap: '5' }}><a href="mailto:research-screening@straumann.com" style={{ display: 'flex', textDecoration: 'none' }}><span style={{ marginRight: '5px' }}>Contact us</span><Icon iconName="Mail" style={{ position: 'relative', top: '2px' }} /></a></Stack>
                                    <Dialog
                                        isBlocking={true}
                                        isOpen={this.state.isDeleteConfirmationOpen}
                                        onDismiss={this.onDismissDeleteDialog}
                                        title="Delete Confirmation"
                                        subText="Are you sure you want to delete this proposal?"
                                        isDarkOverlay={true}
                                        dialogContentProps={{ showCloseButton: false }}
                                    >
                                        <DialogFooter>
                                            <Stack tokens={{ childrenGap: '10' }}>
                                                <Stack horizontal horizontalAlign={'end'} tokens={{ childrenGap: '10' }}>
                                                    <PrimaryButton onClick={this.onDeleteClicked} text="Delete" disabled={this.state.isDeleting} />
                                                    <DefaultButton onClick={this.onDismissDeleteDialog} text="Cancel" disabled={this.state.isDeleting} />
                                                </Stack>
                                                <Stack horizontal horizontalAlign={'end'}>
                                                    {this.state.isDeleting && <Spinner label="Deleting Proposal..." labelPosition={'right'} />}
                                                </Stack>
                                            </Stack>
                                        </DialogFooter>
                                    </Dialog>
                                </div>

                            </div>



                        </div>
                    </div>
                </div>

            </>
        );
    }
}